import styled from '@emotion/styled'
import { colors } from '../../__styling/settings/colors'
import { breakpoint } from '../../__styling/style-functions'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { themedValue } from '../../__styling/themed-value'

export const StyledSimpleTextBanner = styled('div')(({ theme }) => ({
    position: 'relative',
    textAlign: 'center',
    padding: calcRem(theme.margins.sm, theme.margins.md),
    background: themedValue(theme, {
        thewest: colors.thewest.greyErmine,
        fallback: colors.white,
    }),

    [breakpoint('sm')]: {
        padding: calcRem(theme.margins.lg, theme.margins.md),
    },
}))

export const StyledMessageBannerContent = styled('div')(({ theme }) => ({
    position: 'relative',
    maxWidth: calcRem(760),
    margin: '0 auto',
    color: themedValue(theme, {
        thewest: colors.thewest.greyGorilla,
        sevennews: colors.sevennews.charade,
        perthnow: colors.perthnow.greyCoal,
    }),
    fontFamily: theme.fonts.body,

    '*:first-child': {
        marginTop: 0,
    },

    '*:last-child': {
        marginBottom: 0,
    },
}))
